export default __webpack_public_path__ + "static/media/users_1.3c835856.svg";